import {NetworkAPIVersion, NetworkParamType} from './network.utils';

export default {
  getList: {
    url: 'api/memories/{tree_id}/requests/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    params: {
      asset_id: [NetworkParamType.string],
    },
  },
  create: {
    url: 'api/memories/{tree_id}/requests/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      asset_id: [NetworkParamType.string],
      prompt: [NetworkParamType.string],
      auto_transcribe: [NetworkParamType.boolean],
    },
  },
  update: {
    url: 'api/memories/{memory_request_id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'patch',
    params: {
      prompt: [NetworkParamType.string],
      auto_transcribe: [NetworkParamType.boolean],
    },
  },
  sendEmailRequest: {
    url: 'api/memories/{memory_request_id}/send-request/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    multipart: true,
    params: {
      emails: [NetworkParamType.string],
    },
  },
  getPublic: {
    url: 'api/memories/public/{key}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  postPublic: {
    url: 'api/memories/public/{key}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    multipart: true,
    params: {
      audio: [NetworkParamType.file],
      text: [NetworkParamType.string],
    },
  },
};
